
const MemberManageModel = function (){
    const name = 'MemberManage';
    return {
        name,
        state:{
            condition:{
                name:'',
                mobile:'',
                carNo:'',
            },
            newModal:{
                id:'',
                name:'',
                mobile:'',
                email:'',
                password:'',
                con_password:'',
                permission:'',
                roleId:'',
                sex:'',
                qq:'',
                weibo:'',
                wechat:'',
                idCode:'',
                idType:'',
            },
            list:[],
            page:{
                pageSize:30,
                current:1,
                total:0,
            }
        },
        selectors:(state, props) => {
            const currentState = state[name];
            const selectors = {
                getCondition:()=>currentState.condition,
                getNewModalData:()=>currentState.newModal,
                getList:()=>currentState.list,
                getPage:()=>currentState.page,
            };
            return selectors;
        },
        api:{},
        actions:{
            changeCondition:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_MEMBERCONDITION',
                    key,
                    value
                })
            },
            changeNewModalData:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_MEMBERNEW_MODAL',
                    key,
                    value
                })
            },
            changeList:(list) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_MEMBERLIST',
                    list
                })
            },
            changePage:(page) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_MEMBERPAGE',
                    page
                })
            }
        },
        reducers:{
            condition:(state = MemberManageModel.state.condition, action) => {
                if(action.type === 'CHANGE_MEMBERCONDITION'){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            newModal:(state = MemberManageModel.state.newModal, action) => {
                if(action.type === 'CHANGE_MEMBERNEW_MODAL'){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            page:(state = MemberManageModel.state.page, action) => {
                if(action.type === 'CHANGE_MEMBERPAGE'){
                    return Object.assign({}, state, action.page );
                }
                return state;
            },
            list:(state = MemberManageModel.state.list , action ) => {
                if(action.type === 'CHANGE_MEMBERLIST'){
                    return [ ...action.list ];
                };
                return state;
            }
        }
    }
}();

export default MemberManageModel;


// WEBPACK FOOTER //
// ./src/models/MemberManageModel.js